"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveChangesWarningBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var journey_model_1 = require("@athena-portal/journey-model");
var SaveChangesWarningBanner = /** @class */ (function (_super) {
    __extends(SaveChangesWarningBanner, _super);
    function SaveChangesWarningBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.togglePopup = function () {
            _this.props.interaction.uistate.renewalChangesSaved = true;
            _this.props.interaction.uistate.interactionChangesDetected = false;
            _this.executeEvent("change");
            _this.setState({ showBanner: false });
        };
        _this.navigateToChangePaymentCard = function () {
            _this.props.interaction.uistate.renewalChangesSaved = true;
            _this.props.interaction.uistate.interactionChangesDetected = false;
            _this.executeEvent("blur");
        };
        _this.state = {
            showBanner: true,
            renewalProposal: undefined
        };
        return _this;
    }
    SaveChangesWarningBanner.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe(function (policies) {
                    var wolfPolicies = policies
                        .filter(function (policy) { return policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR); })
                        .sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
                    if (wolfPolicies && wolfPolicies.length > 0) {
                        _this.customerPortalService.getRenewalProposal(wolfPolicies[0].policyNumber).subscribe(function (renewalProposal) {
                            _this.setState({
                                renewalProposal: renewalProposal
                            });
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    SaveChangesWarningBanner.prototype.render = function () {
        var _a;
        var pendingRenewalDate = moment.utc((_a = this.state.renewalProposal) === null || _a === void 0 ? void 0 : _a.headerInfo.startDate, moment.ISO_8601);
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.togglePopup });
        var popupMessage = this.getSetting("popupMessage");
        var leftButtonName = this.getSetting("leftButtonName");
        var rightButtonName = this.getSetting("rightButtonName");
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "falcon-modal", isOpen: this.state.showBanner, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.togglePopup, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex gdpr-title-format", children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/attention_icon_blue.png", alt: "Attention", width: 40, height: 40 }), (0, jsx_runtime_1.jsx)("span", { className: "ml-3 banner-text", children: "You have unsaved changes to your renewal policy" })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: (0, jsx_runtime_1.jsxs)("div", { className: "widget personalInfo-widget gdpr-popup-text-format", children: [(0, jsx_runtime_1.jsx)("p", { children: popupMessage }), (0, jsx_runtime_1.jsxs)("p", { children: ["No payments will be taken until ", pendingRenewalDate.format("D MMMM YYYY, 00:00"), "."] }), (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "Save changes to your renewal policy?" })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "justify-content-center flex-column pl-5 pr-5 pb-3", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next w-100", onClick: this.navigateToChangePaymentCard, children: rightButtonName }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white w-100 mb-0", onClick: this.togglePopup, children: leftButtonName }) })] })] }) }));
    };
    ;
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], SaveChangesWarningBanner.prototype, "customerPortalService", void 0);
    SaveChangesWarningBanner = __decorate([
        (0, journey_model_1.settings)([
            { name: "popupMessage", type: journey_model_1.TypeDescriptions.String },
            { name: "leftButtonName", type: journey_model_1.TypeDescriptions.String },
            { name: "rightButtonName", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], SaveChangesWarningBanner);
    return SaveChangesWarningBanner;
}(plugin_journey_1.WidgetBase));
exports.SaveChangesWarningBanner = SaveChangesWarningBanner;
//# sourceMappingURL=SaveChangesWarningBanner.js.map